const SummaryHow1 = {
  label: 'How to Invest?',
  hide: true,
  sections: [
    {
      type: 'text',
      text: () => {
        return `
        <br />
        <h5>Don't worry! ClearTax will help you invest easily in<br /> the best performing Mutual Funds in India</h5>
        <br>

        <img src="https://assets1.cleartax-cdn.com/clearsave/images/process_v3.png" width="100%" />
        <br>

        <p class="light">
          ClearTax is with you every step of the way.
        </p><br />
        `;
      },
      action: {
        URLParams: `startInvest=1&planId=19&ref=personalised-plan&ref2=growth-button-2${
          typeof window !== 'undefined' && window.recommendationsKey
            ? `&story=${window.recommendationsKey}`
            : ''
        }`,
        label: 'View Recommended Plan',
      },
    },
  ],
};

export default SummaryHow1;



// WEBPACK FOOTER //
// ./components/recommendation/cards/summaryHow1.ts